import React from 'react';
import clsx from 'clsx';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

const variantMap: Record<Variant, { pill: string; dot: string }> = {
  success: { pill: 'bg-success-soft text-success', dot: 'bg-success' },
  warning: { pill: 'bg-warning-soft text-warning', dot: 'bg-warning' },
  danger:  { pill: 'bg-danger-soft text-danger', dot: 'bg-danger' },
  info:    { pill: 'bg-info-soft text-info', dot: 'bg-info' },
  neutral: { pill: 'bg-surface-alt text-text-muted', dot: 'bg-text-muted' },
};

const statusToVariant: Record<string, Variant> = {
  active: 'success',
  trial: 'warning',
  suspended: 'danger',
  expired: 'neutral',
};

// Same pill as slightercrm/src/components/StatusPill.tsx.
export const StatusPill: React.FC<{ status: string; label?: string; variant?: Variant }> = ({ status, label, variant }) => {
  const v = variantMap[variant ?? statusToVariant[status.toLowerCase()] ?? 'neutral'];
  return (
    <span className={clsx('inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold', v.pill)}>
      <span className={clsx('h-1.5 w-1.5 rounded-full', v.dot)} />
      {label ?? status}
    </span>
  );
};
